
$(document).ready(function(){ 
	/* header search icon -- disable if the input is not blank */
	$('.site-header__search-input').on('keyup', function(){
		if ( $('.site-nav__icons.left.mobile .site-header__search-input').val().length > 0){
			$('.site-nav__icons.left.mobile .site-header__search-btn').prop('disabled', false)
 		}
	})
	
	/* header search icon -- disable if the input is not blank */
	$('.site-header__search-input').on('keyup', function(){
		if ( $('.site-nav__icons.left.mobile .site-header__search-input').val().length > 0){
			$('.site-nav__icons.left.mobile .site-header__search-btn').prop('disabled', false)
 		}
	})
	/* this hides nav menu items if they have '- hide' in them */
	$('.site-nav__dropdown-link:contains("- hide")').hide()

	/* PDP "You may also like" recommended products */
	if ( $('.recommended-swatches').length > 0 ){
		/* check the first color variant option of each grid item 
		   in the "You may also like" section
			 -- Uses setInterval/clearInterval, to detect when the section is on the page
		*/
		var interval;
		var count = 0;

		function onloadFunctions()
		{
		    checkIfExists();
		    interval = setInterval(checkIfExists, 100);
		}

		/* ... code ... */

		function checkIfExists()
		{
		    var elemExists = $('.product-recommendations [data-index="option-0"] input').length;
		    var collElemExists = $('.product-recommendations-placeholder-collections').length;
		    var editorialElemExists = $('.eps-slider-wrapper .product-recommendations-placeholder-collections').length;
 		    if(elemExists || collElemExists)
		    {	
		    	if(elemExists){
			    	$('.product-recommendations [data-index="option-0"] input').each(function(index, el){
	  					$(el).prop('checked', true).trigger('click') 
	  				})
		    	} else if (editorialElemExists) {
	    			$('.eps-slider-wrapper .product-recommendations-placeholder-collections input').each(function(index, el){
	    				if ( $(el).attr('data-id') === $(el).attr('data-main-product-id') ){
	  						$(el).prop('checked', true)	
		  					$(el).next('label').trigger('click'); 
	    				}
		  					
		  			})
		    	} else {
		    		$('.product-recommendations-placeholder-collections [data-index="option-0"] input').each(function(index, el){
	  					$(el).prop('checked', true)
	  					$(el).trigger('click')
	  					$(el).next('label').trigger('click');
	  					 
	  				})
		    	}
		      clearInterval(interval);
          $('html, body').animate({ scrollTop: 0 });
		    }
		}
		onloadFunctions();
		
		/* change the value of the select option element on product form when a 
		   color swatch is clicked on the "You may also like" product grid (PDP and collections)
		   */	
    
		$(document).on('click', '.product-recommendations input, .product-recommendations-placeholder-collections input', function(index, elem){
 			var id = $(this).attr('data-id'); 
			$(this).closest('form').find('option').val(id);
 		})
		
		var pdpSlider = $('.product-recommendations-placeholder')
		var collectionsSlider = $('.product-recommendations-collection-slider')
		/* Collections/PDP - "You may also like" recommended slider */
		if ( $(collectionsSlider).length > 0 || $(pdpSlider).length > 0){ 
      		let slidesCount = $('.recom-end-spacing').length
		    if ( slidesCount >= 4 ) {
		      showArrows = true
		    } else {
		      showArrows = false
		    }

			if (collectionsSlider || pdpSlider){

				if ( $('.product-recommendations-collection-slider').attr('data-slicked') === 'true' ) {

					$('[data-slicked]').each(function(){
						$(this).slick({
							infinite: true,
							slidesToShow: 2,
							slidesToScroll: 1,
							prevArrow: $(this).siblings('.eps-slider__prev-arrow'),
							nextArrow: $(this).siblings('.eps-slider__next-arrow'),
							dots: false,
							appendDots: $(this).parent().parent().parent().next('.eps-dots-container'),
							centerMode: false
						});
					});
							
				} else {
					
					$('.product-recommendations-collection-slider').each(function(){
						$(this).slick({
							infinite: true,
							slidesToShow: 4,
							slidesToScroll: 1,
							arrows: showArrows,
							appendArrows: $(this).find('.slick-arrow-container'),
							centerMode: false,
							responsive: [
								{
								breakpoint: 768,
								settings: {
									infinite: true,
									slidesToShow: 2.25,
									slidesToScroll: 2.25,
									centerMode: true,
									arrows: false,
									dots: false
								}
								}  
							]
						});
					});
				}
			}

			/* 
			  - Change image shown when color swatch is clicked 
			  - Next, update button text/availability if the input has the class 'disabled'	
				
			*/
			$('.product-recommendations-collection-slider .variant__button-label.color-swatch').on('click', function() {
        // Display selected swatch border
        $(this).addClass('highlighted')
        if ( $(this).parent().siblings().children('label').hasClass('highlighted') ) {
          $(this).parent().siblings().children('label').removeClass('highlighted')
        }

				var productHandle = $(this).closest('.custom-product-swatch-slider').attr('data-handle')
				var img = $(this).closest('.grid-product__content').find('.grid-product__image')
 				fetch('/products/' + productHandle + '.json')
				   .then(response => response.json())
				   .then(data => { 
				       var imgUrl = data.product.image.src  
					   img.attr('srcset', imgUrl)
					   img.attr('data-srcset', imgUrl) 
					})
				/* Update ATC button disabled state and text */
				/* Then update 'Sold Out' tag */   
				var labelStatus = $(this);
				if ( labelStatus.hasClass('disabled') ){
					console.log('not available');
					var atcButton = $(this).closest('form').find('button.add-to-cart');
					var atcButtonText = $(this).closest('form').find('button.add-to-cart span');
					var tag = $(this).closest('.grid__item').find('span.grid-product__tag');
					$(atcButton).prop('disabled', true);
					$(atcButtonText).text('SOLD OUT');
					$(tag).text('SOLD OUT');
				} else {
					console.log('available')
					var atcButton = $(this).closest('form').find('button.add-to-cart');
					var atcButtonText = $(this).closest('form').find('button.add-to-cart span');
					var tag = $(this).closest('.grid__item').find('span.grid-product__tag');
					$(atcButton).prop('disabled', false);
					$(atcButtonText).text('ADD TO BAG');
					$(tag).text('');
				}  
			})


			/* show how many more color swatches are not shown on mobile */
			if (window.matchMedia("(max-width: 768px)").matches){
				$('.product-recommendations-collection-slider .grid__item').each(function(){
					var swatchTotal = $('.custom-product-swatch', this).length
 					if (swatchTotal > 4){
						var moreSwatchCount = swatchTotal - 4;
						var prodHandle = $(this).attr('data-product-handle')
						moreSwatches = '<a href="/products/' + prodHandle + '" class="moreSwatches" style="position: absolute;margin-left: 7.5px;"><p>+ '+moreSwatchCount+'</p></a>' 
						$('.variant-input-wrap', this).append(moreSwatches)
						$(moreSwatches).addClass('more-swatches')
					} 
				})
			}
			/* same as above but for editorial section on collection-landing template */
			if (window.matchMedia("(max-width: 768px)").matches){
				var swatchEl = $('.product-recommendations-collection-slider .grid__item')
				// show how many more swatches are hidden		
				$('.product-recommendations-collection-slider .grid__item').each(function(){
					var swatchTotal = $('.custom-product-swatch-slider', this).length
 					if (swatchTotal > 4){
						var moreSwatchCount = swatchTotal - 4;
						var prodHandle = $(this).attr('data-product-handle')
						moreSwatches = '<a href="/products/' + prodHandle + '" class="moreSwatches" style="position: absolute;margin-left: 7.5px;"><p>+ '+moreSwatchCount+'</p></a>' 
						$('.variant-input-wrap', this).append(moreSwatches)
						$(moreSwatches).addClass('more-swatches')
						// hide the rest of the swatches
						$('.custom-product-swatch-slider', this).each(function(i){
							if (i > 3){
								$(this).hide()
							}
						})
					} 
				})
			}		
		}	
	}


	$('.cart-note-container label.add-cart-note').on('click', function(){
		if ( $(this).prev().is(':checked') ){
			$(this).prev().prop('checked', false);
			$('.gift-note-hidden').val('No').trigger('change'); 
		} else {
			$(this).prev().prop('checked', true);
			$('.gift-note-hidden').val('Yes').trigger('change'); 
		}
		if ( $('#CartNote').length > 0 ){
			$('#CartNote').toggleClass('active');
		} else {
			$('#CartNoteDrawer').toggleClass('active');
			$('.cart-note-container .variant').toggleClass('active');
		}
	})

	/* Gift message / cart note show number of characters used */
	/* on page load, get the value of the text area and show how many chars are already used */
	if ($('#CartNote').length > 0 ){
		$('.char-count').text($('#CartNote').val().length + 1 + '/250')
	} else {
		$('.char-count').text($('#CartNoteDrawer').val().length + 1 + '/250')
	}
	/* Change the number of used characters on the cart note textarea element on key up */
	$('#CartNote, #CartNoteDrawer').on('keyup', function(){
		if ( $(this).val().length > 255 ){
			return false;
		} else if ($(this).val().length == 0){
			$('.char-count').text( $(this).val().length + '/250')	
		} else {
			$('.char-count').text( $(this).val().length + '/250')
		}
	})

	function pageLoadEvents(){
		
	}
	/* Get cart contents, save it to window object */
	function getCart(){
		$.getJSON({
		  url: "/cart.js"
		})
		.done(function(data) {
		  window.acdc = data 
		})
	}
	/* Ajax Add to cart - Promise version */
	function ajaxAtcPromise(variantId, sku, quantity, page, cartItemTitle){
	  return new Promise((resolve) => {
	    //console.log('change quantity function: ')
	    //console.log('variantId: ' + variantId)
	    //console.log('quantity: ' + quantity)
	    var data =  {                        
	                  'id': variantId,
	                  'quantity': quantity,
	                  'properties': {
	                  	'_products': sku,
	                  	'_title': cartItemTitle
	                  }
	                }
	    $.ajax({
	      url: '/cart/add.js',
	      dataType: 'json',
	      cache: false,
	      type: 'post',
	      data: data,
	      beforeSend: function() {
	        
	      },
	      success: function(itemData) {
	        //console.log('Quantity Add: success')
	        if (page == 'cart'){
	        	location.reload()
	        } else {
	          //ajaxGetCartUpdateCart();    
	        }
	        
	      },
	      error: function (jqXHR, textStatus, errorThrown) { 
	        //console.log("Status: " + textStatus); 
	        //console.log("Error: " + errorThrown); 
	      } 
	    })
	    //console.log('resolve: ajaxAtcPromise')
	    resolve();
	  })
	}

	/* Ajax Change Quantity - Promise version */
	/* used to reduce quantity of gift wrap item to zero 0 */
	function ajaxChangeQuantityPromise(variantId, sku, quantity, page){
	  return new Promise((resolve) => {
	    
	    var lineItemKey, data;

	    window.acdc.items.forEach(function(el, index){
	      if (el.properties._products === sku){
	      	lineItemKey = el.key;	 
		    
		    data =  {                        
		                'id': lineItemKey,
		                'quantity': quantity,
		            }
	      }  	  
	    })
	    
	    $.ajax({
	      url: '/cart/change.js',
	      dataType: 'json',
	      cache: false,
	      type: 'post',
	      data: data,
	      beforeSend: function() {
	        
	      },
	      success: function(itemData) { 
	        if (page == 'cart'){
	        	location.reload()
	        }  
	        
	      },
	      error: function (jqXHR, textStatus, errorThrown) {  
	      } 
	    }) 
	    resolve();
	  })
	}

	$('.custom-product-swatch').click((e)=>{
		setTimeout(function(){
			e.preventDefault();
			let input = $('.variant__button-label.active').prev();
			let leatherUrl = input.data('leather-type-image');
			$('.leather-image').attr('src', leatherUrl)
		}, 100)
	})

	/* Our leathers page - featured collection text image slider  */
	if ( $('.text-image-slider').length > 0 && $('.text-image-slider .grid__item').length > 4 ){
		$('.text-image-slider .featured-row').slick({
			infinite: false,
			slidesToShow: 3.5,
			slidesToScroll: 1,
			arrows: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						infinite: false,
						slidesToShow: 1.5,
						slidesToScroll: 1,
						arrows: false,
						dots: false
					}
				}  
			]
		})
	}
	
 var _learnq = window._learnq || [];
 var buttons = document.querySelectorAll('button[data-add-to-cart], a[data-add-to-cart]');
 buttons.forEach(button => {
	 button.addEventListener('click', function (e) {
		fetch(window.Shopify.routes.root + 'cart.js')
			 .then(response => response.json())
			 .then(data => {
				 var itemList = [];
				 data['items'].forEach(function (item, i) {
					 var itemObj = new Object();
					 itemObj.variant_id = item['variant_id'];
					 itemObj.sku = item['sku'];
					 itemObj.title = item['product_title'];
					 itemObj.quantity = item['quantity'];
					 itemObj.price = item['price'] / 100;
					 itemObj.RowTotal = item['line_price'] / 100;
					 itemObj.url = Shopify.shop + item['url'];
					 itemObj.image = item['featured_image']['url'];
					 itemList.push(itemObj);
				 });
				 _learnq.push(['track', 'Added to Cart',
					 {
						 "ProductID": button.getAttribute('data-id'),
						 "quantity": 1,
						 "Price": button.getAttribute('data-price'),
						 "URL": button.getAttribute('data-url'),
						 "Origin":button.getAttribute('data-origin'),
						 "ImageURL": button.getAttribute('data-image'),
						 "Name": button.getAttribute('data-title'),
						 "Categories": button.getAttribute('data-collections')?.split('|'),
						 'items': itemList
					 }
				 ]);
			 });
	 });
 });

})

window.addEventListener('DOMContentLoaded', (event) => {
 
  /* All gift wrapping logic happens in here. */ 
    /* AJAX add item to cart, update cart counter, toggle cart drawer */
    /* Collections - You may also like - product recommendations ATC */
    /* also used on product-w-swatch blog article section */
	$(document).on('click', '.product-recommendations-placeholder.w-swatches .add-to-cart, .product-recommendations-placeholder .add-to-cart, .product-recommendations-placeholder-collections.w-swatches .add-to-cart, .product-w-swatch .add-to-cart', function(e){
		e.preventDefault();
		var id = parseInt($(this).closest('form').find('input:checked').attr('data-id'))
		if(!id || id.length == 0){
			// for YMAL on PDP
			id = parseInt($(this).attr("data-card-variant-id"))
			// console.log('parse in IF ', id)
		}
		var data;
		// Check if item is on Final Sale
		// To add line item property on ATC 
		const onFinalSale = $(this).closest("form").find('input[value="FINAL SALE"]')
		if(onFinalSale && onFinalSale.length > 0 ){ 
			data = {
				'items': [{
					id: id,
					quantity: 1,
					properties: {
						"ITEM": "FINAL SALE"
					}
				}]
			}
		}else{
			// If item is not on final sale:
			data = {
				'items': [{
					id: id,
					quantity: 1
				}]
			}
		}
 
		// debugger
		fetch(theme.routes.cartAdd, {
		  method: 'POST',
		  body: JSON.stringify(data),
		  dataType: 'json',
		  headers: {
		    'Content-Type': 'application/json',
		    'X-Requested-With': 'XMLHttpRequest'
		  }
		})
		.then(response => response.json())
		.then(function(data) {
		  if (data.status === 422) {
		    this.error(data);
		  } else {
		    var product = data;
		    //this.success(product);
		    document.dispatchEvent(new CustomEvent('cart:build'));
		    document.dispatchEvent(new CustomEvent('cart:open'));
		  }
		
		});

	})

  $('[data-card-variant-id]').on('click', function(e) {
    e.preventDefault();
	var id = parseInt($(this).attr('data-card-variant-id'))
	let source = $(this).attr('data-gtm-atc-source');
	let sourceProps;
	if (source == "pdp-main") {
		sourceProps = {"_go-pdp-main": true}
	} else if (source == "mini-cart-upsell") {
		sourceProps = {"_cart-upsell": true}
	} else {
		sourceProps ={}
	}
	var preOrder = $(e.target).closest('form').find('input[name="properties[PRE_ORDER]"]')
	var finalSale =  $(e.target).closest('form').find('input[name="properties[ITEM]"]')
	let preOrderDate = ""
	if(preOrder && preOrder.length > 0){
		preOrderDate = $(e.target).closest('form').find('input[name="properties[PRE_ORDER]"]').val()
	}
	if (preOrderDate && preOrderDate != "") {
		const dates = preOrderDate.split("-")
		const month = dates[1]
		const day = dates[2]
		// console.log($(this).attr('data-card-variant-id'))
		  var data = {
			'items': [{
			  id: id,
			  quantity: 1,
			  properties: {
				PRE_ORDER: "(Shipping " + month + "/" + day + ")"
			  }
			}]
		  }
		
	}else if (finalSale && finalSale.length > 0){
		var finalSaleValue = $(e.target).closest('form').find('input[name="properties[ITEM]"]').val()
		if ( finalSaleValue.includes('FINAL SALE')) {
		  var data = {
			'items': [{
			  id: id,
			  quantity: 1,
			  properties: {
				ITEM: 'FINAL SALE'
			  }
			}]
		  }
		}
    } else {
      var data = {
        'items': [{
          id: id,
          quantity: 1,
					properties: sourceProps
        }]
      }
    }
		fetch(theme.routes.cartAdd, {
		  method: 'POST',
		  body: JSON.stringify(data),
		  dataType: 'json',
		  headers: {
		    'Content-Type': 'application/json',
		    'X-Requested-With': 'XMLHttpRequest'
		  }
		})
		.then(response => response.json())
		.then(function(data) {
		  if (data.status === 422) {
		    this.error(data);
		  } else {
		    var product = data;
		    //this.success(product);
		    document.dispatchEvent(new CustomEvent('cart:build'));
		    document.dispatchEvent(new CustomEvent('cart:open'));
		  }
		
		});
  })
    

    getCart();

    /* check if dom elements exist before trying to target them */
    var interval;

    function onloadFunctions(){
        checkIfDomElExists();
        interval = setInterval(checkIfDomElExists, 500);
    }

		function checkIfDomElExists(){
    	var domEl = $('[data-sku]')
        
      if(domEl){
      	
        //console.log('element exists in dom');
        pageLoadEvents();
        clearInterval(interval);
      }
    }
    onloadFunctions();

    /* Get cart contents, save it to window object */
    function getCart(){
    	return new Promise((resolve) => {
	    	$.getJSON({
	    	  url: "/cart.js"
	    	})
	    	.done(function(data) {
	    	  window.acdc = data 
	    	})
	    })
    }

    /* On initial page load, iterate through each normal product [data-sku] and 
       then check if there is an associated gift wrap product. If there is, check the 
       normal products checkbox
    */
    function pageLoadEvents(){ 
    		$('[data-sku]').each(function(index, el){
    			var thisSku = $(this).attr('data-sku') 
    			
    			if ( $('[data-associated-sku="' + thisSku + '"]').length > 0 ){
    				var associatedSku = $(this).attr('data-sku'); 
    				$('[data-sku="' + associatedSku + '"]').prop('checked', true);
    			} else {
    			}
    		})	
    		/* on page load, iterate through each gift wrap product and make sure there
    		   is a normal product still in the cart. If there is not, remove the gift wrap
    		   product from the cart
    		*/
    		$('[data-associated-sku]').each(function(index, el){
    			var thisAssociatedSku = $(this).attr('data-associated-sku');
    			var page = $(this).attr('data-page'); 

    			if ( ! $('[data-sku="' + thisAssociatedSku + '"]').length > 0 ){
					if ( ! $('[data-title="' + thisAssociatedSku + '"]').length > 0){
						var variantId = $(this).attr('data-id');
						var quantity = 0;
 						setTimeout(function(){ 
							ajaxChangeQuantityPromise(variantId, thisAssociatedSku, quantity, page)
						}, 500)
					}
    			}
    		})
    	
    }

    /* Ajax Add to cart - Promise version */
    function ajaxAtcPromise(variantId, sku, quantity, page, cartItemTitle){
      return new Promise((resolve) => { 

        var data =  {                        
                      'id': variantId,
                      'quantity': quantity,
                      'properties': {
                      	'_products': sku,
                      	'_title': cartItemTitle
                      }
                    }
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: data,
          beforeSend: function() {
            
          },
          success: function(itemData) {
            //console.log('Quantity Add: success')
            if (page == 'cart'){
            	location.reload()
            } else {
              document.dispatchEvent(new CustomEvent('cart:build'));
              getCart().then( setTimeout(function(){
              		pageLoadEvents()
              	}, 1500)
              );
               
            }
            
          },
          error: function (jqXHR, textStatus, errorThrown) { 
            console.log("Status: " + textStatus); 
            console.log("Error: " + errorThrown); 
          } 
        }) 
        resolve();
      })
    }

    /* Ajax Change Quantity - Promise version */
    /* used to reduce quantity of gift wrap item to zero 0 */
    function ajaxChangeQuantityPromise(variantId, sku, quantity, page){
      return new Promise((resolve) => {
        
        var lineItemKey, data;

        window.acdc.items.forEach(function(el, index){
          if (el.properties._products !== null && el.properties._products === sku){
          	lineItemKey = el.key;	 
    	    
    	    data =  {                        
    	                'id': lineItemKey,
    	                'quantity': quantity,
    	            }
          }  	  
        })
        
        $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: data,
          beforeSend: function() {
            
          },
          success: function(itemData) {
            //console.log('Quantity Change: success')
            if (page == 'cart'){
            	location.reload()
            } else {
              //ajaxGetCartUpdateCart(); 
              document.dispatchEvent(new CustomEvent('cart:build'));
              getCart().then( setTimeout(function(){
              		pageLoadEvents()
              	}, 1500)
              ); 
            }
            
          },
          error: function (jqXHR, textStatus, errorThrown) {  
          } 
        }) 
        resolve();
      })
    }

    /* on-click events */
    
    /* gift card price */
    if ( $('.template-giftcard .variant-input input').length > 0 ){
    	$('.template-giftcard .variant-input input').on('change', function(){
    		var price = $('.template-giftcard .variant-input input:checked').val() + '.00';
    		$('.gift-card-price').text(price);
			let urlParams = new URLSearchParams(window.location.search);
			if(urlParams.has('variant')) {
				let variantId = urlParams.get('variant');
				$('.template-giftcard button[data-add-to-cart]').attr('data-card-variant-id', variantId);
				$('.template-giftcard .product-block input[name=product-id]').attr('value', variantId);
			}
    	});
		$('.template-giftcard .variant-input').on('click', function() { 
			$('.variant__button-label').blur();
			$(this).find('.variant__button-label').focus();
		})		
    }
    
    $(document).on('click', '.gift-wrap-container .add-wrap-note', function(){
    	var cartItemTitle = $(this).prev().attr('data-title');
    	var cartItemSku = $(this).prev().attr('data-sku');
    	var giftWrapId = '40418787885110';
    	var quantity = 0;
    	var page = $(this).prev().attr('data-page');
 

    	if ( $(this).prev().is(':checked') ){
    		$(this).prev().prop('checked', false);
    		ajaxChangeQuantityPromise(giftWrapId, cartItemSku, quantity, page)
     	} else {
    		$(this).prev().prop('checked', true);
    		var quantity = 1;
    		ajaxAtcPromise(giftWrapId, cartItemSku, quantity, page, cartItemTitle);
    		 
    	} 
		// Updates for free shipping progress bar
		setTimeout(() => {
            let shippingMetEl = document.getElementById('modal-shipping_thresh--met')
            let shippingNotMetEl = document.getElementById('modal-shipping_thresh--not_met')
            let shippingThreshDiffEl = document.getElementById('modal-shipping_thresh--difference')
            let shippingThreshBarEl = document.getElementById('modal-thresh-bar')
    
            let threshFull = $('.shipping_thresh--wrapper').attr('data-shipping-thresh')
            let thresh = Math.floor(threshFull / 100)
            let cartStringFull = document.getElementById('modal-cart-subtotal').innerHTML
            let cartStringPartial = cartStringFull.replace("$", "")
            let cartNum = Number(cartStringPartial)
            let difference = thresh - cartNum
            let percentage = ( cartNum / thresh ) * 100
                percentage = Math.round(percentage * 10) / 10
                if ( percentage > 100) {
                    percentage = 100
                }
    
            shippingThreshBarEl.style.width = percentage + "%"
            if ( difference >= 0 ) {
                shippingMetEl.style.display = "none"
                shippingNotMetEl.style.display = "block"
                shippingThreshDiffEl.innerHTML = "$" + difference
            } else if ( difference < 0 ) {
                shippingNotMetEl.style.display = "none"
                shippingMetEl.style.display = "block"
            } 
        }, 1000)
		setTimeout(() => {
            let shippingMetEl = document.getElementById('shipping_thresh--met')
            let shippingNotMetEl = document.getElementById('shipping_thresh--not_met')
            let shippingThreshDiffEl = document.getElementById('shipping_thresh--difference')
            let shippingThreshBarEl = document.getElementById('thresh-bar')
    
            let threshFull = $('.shipping_thresh--wrapper').attr('data-shipping-thresh')
            let thresh = Math.floor(threshFull / 100)
            let cartStringFull = document.getElementById('cart-subtotal').innerHTML
            let cartStringPartial = cartStringFull.replace("$", "")
            let cartNum = Number(cartStringPartial)
            let difference = thresh - cartNum
            let percentage = ( cartNum / thresh ) * 100
                percentage = Math.round(percentage * 10) / 10
                if ( percentage > 100) {
                    percentage = 100
                }
    
            shippingThreshBarEl.style.width = percentage + "%"
            if ( difference >= 0 ) {
                shippingMetEl.style.display = "none"
                shippingNotMetEl.style.display = "block"
                shippingThreshDiffEl.innerHTML = "$" + difference
            } else if ( difference < 0 ) {
                shippingNotMetEl.style.display = "none"
                shippingMetEl.style.display = "block"
            } 
        }, 1000)
    })
	// end of updates for free shipping progress bar

    /* when quantity +- is clicked, check to make sure the gift wrap items should still be 
       present in the cart */
    $(document).on('click', '.js-qty__adjust--minus', function(){
    	getCart()
    	setTimeout(function(){
    		//console.log('--- Qty click ---')
    		pageLoadEvents();
    	},1000)
    })
});

$(window).on('load', function(){
	console.log('window.load fired - modified');
	    /* Get cart contents, save it to window object */
		function getCart(){
			return new Promise((resolve) => {
				$.getJSON({
				  url: "/cart.js"
				})
				.done(function(data) {
				  window.acdc = data 
				})
			})
		}

		function pageLoadEvents(){ 
				$('[data-sku]').each(function(index, el){
					var thisSku = $(this).attr('data-sku') 
					
					if ( $('[data-associated-sku="' + thisSku + '"]').length > 0 ){
						var associatedSku = $(this).attr('data-sku'); 
						$('[data-sku="' + associatedSku + '"]').prop('checked', true);
					} else {
					}
				})
				/* remove any gift wrap items that dont have an associated product */
					$('[data-associated-sku]').each(function(index, el){
					var thisAssociatedSku = $(this).attr('data-associated-sku');
					var page = $(this).attr('data-page'); 

					if ( ! $('[data-sku="' + thisAssociatedSku + '"]').length > 0 ){
						if ( ! $('[data-title="' + thisAssociatedSku + '"]').length > 0){
							var variantId = $(this).attr('data-id');
							var quantity = 0;
 							setTimeout(function(){
								//debugger
								ajaxChangeQuantityPromise(variantId, thisAssociatedSku, quantity, page)
							}, 500)
						}
					}
				})
			
		}

	    /* Ajax Change Quantity - Promise version */
    /* used to reduce quantity of gift wrap item to zero 0 */
    function ajaxChangeQuantityPromise(variantId, sku, quantity, page){
		return new Promise((resolve) => {
		  
		  var lineItemKey, data;
  
		  window.acdc.items.forEach(function(el, index){
			if (el.properties._products !== null && el.properties._products === sku){
				lineItemKey = el.key;	 
			  
			  data =  {                        
						  'id': lineItemKey,
						  'quantity': quantity,
					  }
			}  	  
		  })
		  
		  $.ajax({
			url: '/cart/change.js',
			dataType: 'json',
			cache: false,
			type: 'post',
			data: data,
			beforeSend: function() {
			  
			},
			success: function(itemData) {
			  //console.log('Quantity Change: success')
			  if (page == 'cart'){
				  location.reload()
			  } else { 
				getCart().then( setTimeout(function(){
						pageLoadEvents()
						document.dispatchEvent(new CustomEvent('cart:build'));
					}, 1500)
				);
				 
			  }
			  
			},
			error: function (jqXHR, textStatus, errorThrown) {  
			} 
		  })
		  //console.log('resolve: ajaxChangeQuantityPromise')
		  resolve();
		})
	  }
	/* Gift card template -- on page load, click the radio input ;label adjacent to the one that is selected, 
	   then click the correct label, really bad, but it fixes this broken section */
	if ( $('.template-giftcard').length > 0 ){
		$('.variant-input-wrap input[type="radio"]:checked').parent().next().find('label').trigger('click').parent().prev().find('label').trigger('click')
	}
	/* Gift wrapping - On page load: 
			- iterate through each product with data-sku attribute, 
			  then check if theres another product present in the cart that has 
			  data attribute data-associated-sku (this would be a gift wrap product), 
			  if there is, check the "gift wrap this item" checkbox on the original (not gift wrap)
			  product

			- next - iterate through each gift wrapping item, check if theres an associated 
			  normal product in the cart. If there isnt, that means the normal product has
			  been removed and we need to remove the gift wrapping item from the cart  
	*/
	if ($('[data-sku]').length > 0 ){
		$('[data-sku]').each(function(index, el){
			var thisSku = $(this).attr('data-sku') 
			
			if ( $('[data-associated-sku="' + thisSku + '"]').length > 0 ){
				var associatedSku = $(this).attr('data-sku'); 
				$('[data-sku="' + associatedSku + '"]').prop('checked', true);
			} else {
			}
		})	
	}
})
